import { Business } from './business';
import { Locale } from './locale';
import { PaymentProvider } from './payment_provider';

export interface PaymentAccount {
  id?: string;
  name?: string;
  number?: string;
  number_display?: string;
  code?: string;
  label?: string;
  type?: AccountType;
  payment_provider?: PaymentProvider;
  country?: Locale | string;
  business?: Business | string;
}

export interface AccountType {
  id: string;
  name?: string;
  code?: AccountTypeCode;
  icon?: string;
  translations?: AccountType[];
}

export enum AccountTypeCode {
  MOMO = 'MOMO',
  MOMO_CODE = 'MOMO_CODE',
  BANK = 'BANK',
  BANK_CODE = 'BANK_CODE',
}
